function Cinema_filter_date(element) {
  this.dataLocale = element.dataset.locale;
  this.dataEnabled = element.dataset.enabled.split(',');

  this.init = function () {
    var that = this;
    var $element = $('#cinema_date').flatpickr(
      {
        altInput: true,
        altFormat: "d.m.Y",
        dateFormat: "Y-m-d",
        locale: this.dataLocale,
        onClose: function () {
          document.querySelector('.c-admin-filterbar__item svg.clear_date').classList.remove('hidden');
        },
        enable: this.dataEnabled
      }
    );

    $('svg.clear_date').on('click', function () {
      $element.clear();
      document.querySelector('.c-admin-filterbar__item svg.clear_date').classList.add('hidden');
    });

    // $('#cinema_showall').on('click', function () {
    //   that.toggleDormant();
    // });
    //
    // this.toggleDormant();
  };

  // this.toggleDormant = function () {
  //   var element = document.querySelector('#cinema_showall');
  //   var dormants = document.querySelectorAll('.dormant');
  //   for (let i = 0; i < dormants.length; i++) {
  //     var dormant = dormants[i];
  //     if (element.checked) {
  //       dormant.classList.remove('hidden');
  //     } else {
  //       dormant.classList.add('hidden');
  //     }
  //   }
  // }
}
